// extracted by mini-css-extract-plugin
export default {"item":"AnimatedTabItem-module__item","icon":"AnimatedTabItem-module__icon"};